/*
 *
 * CostsCustomDownloadModal
 *
 * @version 1.0.0
 * @author Ivana Piscitelli
 * @since 16-Jul-2025
 */

import React, { useState } from 'react'
import PropTypes from 'prop-types'
import Toggle from 'Hoc/ToggleComponent'
import { DocumentCVS, DocumentXLS, ExclamationCircle } from '@nexidigital/iconlibrary'
import { useMobileDetect } from 'Hoc/ListenerProvider'
import MerchantModal from '@nexidigital/merchantmodal'
import MerchantGenericCard from '@nexidigital/merchantgenericcard'
import PortalRadioBox from '@nexidigital/portalradiobox'
import MerchantToastMessage from '@nexidigital/merchanttoastmessage'
import formattedMessage from './languageModule'
import './CostsCustomDownloadModal.scss'

const CostsCustomDownloadModal = (props) => {
  const [downloadType, setDownloadType] = useState(null)
  const [downloadingFormat, setDownloadingFormat] = useState(null)
  const { isSmallScreen } = useMobileDetect()

  const handleDownloadTypeRadio = (value) => {
    setDownloadType(value)
  }

  const handleGetDownload = (format) => {
    setDownloadingFormat(format)

    const payload = {
      request: {
        ...props.filters
      },
      paymentsDownloadData: {
        downloadType,
        format
      }
    }
    if (downloadType === 'TRANSACTIONS') {
      props.asyncDownload(payload)
    } else {
      props.syncDownload(payload)
    }
  }

  // Check if an option is selected
  const isOptionSelected = downloadType !== null

  return (
    <Toggle>
      <MerchantModal
        title={props.title}
        description={props.description}
        onClose={props.onClose}
        withoutButton={!isOptionSelected}
        primaryButtonLabel={isOptionSelected ? props.primaryButtonLabel : undefined}
        primaryAction={isOptionSelected ? () => handleGetDownload('EXCEL') : undefined}
        primaryIcon={isOptionSelected ? <DocumentXLS size='20' type='line' /> : undefined}
        primaryButtonLoading={
          isOptionSelected
            ? (props.isAsyncDownloadLoading || props.isSyncDownloadLoading) && downloadingFormat === 'EXCEL'
            : undefined
        }
        primaryButtonTertiary={isOptionSelected}
        secondaryButtonLabel={isOptionSelected ? props.secondaryButtonLabel : undefined}
        secondaryAction={isOptionSelected ? () => handleGetDownload('CSV') : undefined}
        secondaryIcon={isOptionSelected ? <DocumentCVS size='20' type='line' /> : undefined}
        secondaryButtonLoading={
          isOptionSelected
            ? (props.isAsyncDownloadLoading || props.isSyncDownloadLoading) && downloadingFormat === 'CSV'
            : undefined
        }
        secondaryButtonTertiary={isOptionSelected}
        disableBackdropClick
        customAnalyticsDescription={props.titleMerchantGenericCard}
      >
        <div className='costsCustomDownloadModal'>
          <MerchantGenericCard title={props.titleMerchantGenericCard}>
            <div className='costsCustomDownload'>
              <p className='costsCustomText'>{props.subtitleMerchantGenericCard}</p>
              <PortalRadioBox
                id='downloadTypeRadio'
                radioGroupName='downloadType'
                row={!isSmallScreen}
                noPreselection
                onChange={(value) => handleDownloadTypeRadio(value)}
                options={props.options}
                type='radio'
                centered
              />
              {props.isBlockedDownload && <p className='costsCustomText'>{formattedMessage.labelBlackListedMessage}</p>}
            </div>
            {props.children}
          </MerchantGenericCard>

          {downloadType === 'TRANSACTIONS' && (
            <div className='infoMessage'>
              {props.formatInfoMessage && <div className='infoMessageText'>{props.formatInfoMessage}</div>}
              <div className='downloadMessage'>
                <MerchantToastMessage severity='info' showOnPage hideClose label={props.labelMerchantToastMessage} icon={<ExclamationCircle size='24' type='line' />} />
              </div>
            </div>
          )}
        </div>
      </MerchantModal>
    </Toggle>
  )
}

CostsCustomDownloadModal.propTypes = {
  children: PropTypes.node,
  onClose: PropTypes.func,
  title: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  description: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  primaryButtonLabel: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  secondaryButtonLabel: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  titleMerchantGenericCard: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  subtitleMerchantGenericCard: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  options: PropTypes.array,
  formatInfoMessage: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  labelMerchantToastMessage: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  isAsyncDownloadLoading: PropTypes.bool,
  isSyncDownloadLoading: PropTypes.bool,
  syncDownload: PropTypes.func,
  asyncDownload: PropTypes.func,
  filters: PropTypes.object,
  typeTabDownload: PropTypes.string,
  isDetailsDownload: PropTypes.bool,
  isBlockedDownload: PropTypes.bool
}

CostsCustomDownloadModal.defaultProps = {
  children: null,
  onClose: undefined,
  title: '',
  description: '',
  primaryButtonLabel: undefined,
  secondaryButtonLabel: undefined,
  titleMerchantGenericCard: '',
  subtitleMerchantGenericCard: '',
  options: [],
  formatInfoMessage: '',
  labelMerchantToastMessage: '',
  isAsyncDownloadLoading: false,
  isSyncDownloadLoading: false,
  syncDownload: () => { },
  asyncDownload: () => { },
  filters: {},
  typeTabDownload: '',
  isDetailsDownload: false,
  isBlockedDownload: false
}

export default CostsCustomDownloadModal
